<!-- *** Pre acceptance list *** -->
<ion-row class="new-design" style="margin-bottom: 2em">
    <ion-col size="12" class="row-main-title">
        <div class="title-section ion-margin-top">
            <div class="title-container">
                <ion-label class="title">
                    {{ (toolService.content | async)?.application?.components?.eligibilityDocuments?.componenttitle }}
                </ion-label>
            </div>
        </div>
    </ion-col>
    <ion-col size="12">
        <section class="info-panel">
            <div class="info-icon-container">
                <fa-icon [icon]="icons.faInfoCircle"></fa-icon>
            </div>
            <div class="info-panel-text-container">
                <ion-text>
                    <p class="info-text">
                        <span class="bold-text">{{ (toolService.content | async)?.application?.components?.eligibilityDocuments?.cardcontentbold }}</span>
                        {{ (toolService.content | async)?.application?.components?.eligibilityDocuments?.cardcontentnormal }}
                    </p>
                </ion-text>
            </div>
        </section>
    </ion-col>
    <!-- Resume -->
    <ion-col
        *ngIf="requiredDocumentList?.requireResume && !customResume"
        size="4"
        size-xs="12"
        size-sm="12"
        size-md="12"
        size-lg="4"
        size-xl="4"
        class="requirement-col"
    >
        <div class="requirement-content">
            <div>
                <ion-label class="ion-text-wrap">
                    <fa-icon [icon]="icons.faFile"></fa-icon>
                    <span class="bold-text padding-left">
                        {{ (toolService.content | async)?.application?.components?.generalDocuments?.eligibility?.resumebutton }}
                    </span>
                </ion-label>
                <p *ngIf="requiredDocumentList?.requireResume">
                    <a class="learn-more" (click)="openTooltip($event, 'cv', 'question')">
                        <fa-icon [icon]="icons.faInfoCircle" slot="start"></fa-icon>
                        <span>Learn more</span>
                    </a>
                </p>
            </div>
        </div>
    </ion-col>
    <ion-col
        *ngIf="requiredDocumentList?.requireResume && !customResume"
        class="requirement-col"
        size="4"
        size-xs="6"
        size-sm="6"
        size-md="6"
        size-lg="4"
        size-xl="4"
    >
        <div class="requirement-content">
            <div class="ion-text-center" *ngIf="requiredDocumentList?.requireResume">
                <div class="ion-text-center">
                    <div>
                        <ion-button
                            [disabled]="checklistStatus | checklist : 'cv'"
                            (click)="upload('cv', 'none')"
                            fill="clear"
                            color="primary"
                            class="upload-btn"
                        >
                            <fa-icon [icon]="icons.incompleted"></fa-icon>
                            {{ userDocuments?.cv ? 'Upload New Document' : 'Upload Document' }}
                        </ion-button>
                    </div>
                </div>
            </div>
        </div>
    </ion-col>
    <ion-col
        *ngIf="requiredDocumentList?.requireResume && !customResume"
        class="requirement-col"
        size="4"
        size-xs="6"
        size-sm="6"
        size-md="6"
        size-lg="4"
        size-xl="4"
    >
        <div class="requirement-content" *ngIf="userDocuments.cv">
            <div class="ion-padding-top">
                <div class="ion-text-center">
                    <ion-button (click)="viewBasicDocument('cv')" class="upload-btn upload-btn-color" fill="clear"> View document </ion-button>
                </div>
                <div class="ion-text-center chip-container-top">
                    <app-document-status-chip [checklist]="checklistStatus" [type]="'cv'"></app-document-status-chip>
                </div>
            </div>
        </div>
    </ion-col>
    <div class="requirement-divider"></div>
    <!-- Deans Letter -->
    <ion-col
        *ngIf="requiredDocumentList?.requireEducation && !customEducation"
        class="requirement-col"
        size="4"
        size-xs="12"
        size-sm="12"
        size-md="12"
        size-lg="4"
        size-xl="4"
    >
        <div class="requirement-content">
            <div>
                <ion-label class="ion-text-wrap">
                    <fa-icon [icon]="icons.faFile"></fa-icon>
                    <span class="bold-text padding-left">
                        {{ (toolService.content | async)?.application?.components?.generalDocuments?.eligibility?.lorbutton }}
                    </span>
                </ion-label>
                <p>
                    You can either upload your school diploma or a letter of recommendation from your dean to fulfill this requirement.
                    <a [routerLink]="[]" (click)="downloadSample()">View Sample</a>
                </p>
            </div>
        </div>
    </ion-col>
    <ion-col
        *ngIf="requiredDocumentList?.requireEducation && !customEducation"
        class="requirement-col"
        size="4"
        size-xs="6"
        size-sm="6"
        size-md="6"
        size-lg="4"
        size-xl="4"
    >
        <div class="requirement-content">
            <div class="ion-text-center" *ngIf="requiredDocumentList?.requireEducation">
                <div>
                    <ion-button
                        [disabled]="checklistStatus | checklist : 'schoolrecords'"
                        (click)="upload('schoolrecords', 'none')"
                        fill="clear"
                        color="primary"
                        class="upload-btn"
                    >
                        <fa-icon [icon]="icons.incompleted"></fa-icon>
                        {{ userDocuments?.schoolrecords ? 'Upload New Document' : 'Upload Document' }}
                    </ion-button>
                </div>
            </div>
        </div>
    </ion-col>
    <ion-col
        *ngIf="requiredDocumentList?.requireEducation && !customEducation"
        class="requirement-col"
        size="4"
        size-xs="6"
        size-sm="6"
        size-md="6"
        size-lg="4"
        size-xl="4"
    >
        <div class="requirement-content" *ngIf="userDocuments.schoolrecords">
            <div class="ion-padding-top">
                <div class="ion-text-center">
                    <ion-button (click)="viewBasicDocument('schoolrecords')" class="upload-btn upload-btn-color" fill="clear"> View document </ion-button>
                </div>
                <div class="ion-text-center chip-container">
                    <app-document-status-chip [checklist]="checklistStatus" [type]="'schoolrecords'"></app-document-status-chip>
                </div>
            </div>
        </div>
    </ion-col>
    <div class="requirement-divider"></div>
    <!-- English -->
    <ion-col
        size="4"
        size-xs="12"
        size-sm="12"
        size-md="12"
        size-lg="4"
        size-xl="4"
        *ngIf="requiredDocumentList?.requireEnglish && !hasUsCanPassport"
        class="requirement-col"
    >
        <div class="requirement-content">
            <div>
                <ion-label class="ion-text-wrap">
                    <fa-icon [icon]="icons.faFile"></fa-icon>
                    <span class="bold-text padding-left">
                        {{ (toolService.content | async)?.application?.components?.generalDocuments?.eligibility?.proficiency }}
                    </span>
                </ion-label>

                <ion-text color="text">
                    <p class="card-text" *ngIf="requiredDocumentList?.requireEnglish && !hasUsCanPassport">
                        <a class="learn-more" (click)="openTooltip($event, 'Proficiency', 'infocircle')">
                            <fa-icon [icon]="icons.faInfoCircle" slot="start"></fa-icon>
                            <span>Learn more</span>
                        </a>
                        <!-- {{ (toolService.content | async)?.application?.components?.generalDocuments?.eligibility?.rightCardBottomContent }} -->
                    </p>
                </ion-text>
            </div>
        </div>
    </ion-col>
    <ion-col
        *ngIf="requiredDocumentList?.requireEnglish && !hasUsCanPassport"
        class="requirement-col"
        size="4"
        size-xs="6"
        size-sm="6"
        size-md="6"
        size-lg="4"
        size-xl="4"
    >
        <div class="requirement-content ion-text-center">
            <ion-button [disabled]="checklistStatus | checklist : 'toefl'" (click)="upload('toefl', 'none')" fill="clear" color="primary" class="upload-btn">
                <fa-icon [icon]="icons.incompleted" slot="start"></fa-icon>
                {{ userDocuments.toefl ? 'Upload New Document' : 'Upload Document' }}
            </ion-button>
        </div>
    </ion-col>
    <ion-col
        *ngIf="requiredDocumentList?.requireEnglish && !hasUsCanPassport"
        class="requirement-col"
        size="4"
        size-xs="6"
        size-sm="6"
        size-md="6"
        size-lg="4"
        size-xl="4"
    >
        <div class="requirement-content ion-text-center" *ngIf="userDocuments.toefl">
            <div class="ion-padding-top">
                <ion-button (click)="viewBasicDocument('toefl')" class="upload-btn upload-btn-color" fill="clear"> View document </ion-button>

                <div class="ion-text-center chip-container">
                    <app-document-status-chip [checklist]="checklistStatus" [type]="'toefl'"></app-document-status-chip>
                </div>
            </div>
        </div>
    </ion-col>

    <div class="requirement-divider"></div>
    <!-- Health Insurance -->
    <ion-col
        size="4"
        size-xs="12"
        size-sm="12"
        size-md="12"
        size-lg="4"
        size-xl="4"
        *ngIf="requiredDocumentList?.requireHealthInsurance"
        class="requirement-col"
    >
        <div class="requirement-content">
            <div>
                <ion-label class="ion-text-wrap">
                    <fa-icon [icon]="icons.faFile"></fa-icon>
                    <span class="bold-text padding-left">
                        {{ (toolService.content | async)?.application?.components?.generalDocuments?.health?.insurance }}
                    </span>
                </ion-label>

                <div class="info-divs">
                    <ion-text
                        color="text"
                        [innerHTML]="
                            (toolService.content | async)?.application?.components?.generalDocuments?.health?.rightCardContentTelehealth | safe : 'html'
                        "
                    >
                    </ion-text>
                    <a class="anchor-btn-info">
                        <fa-icon
                            href="https://www.visitorscoverage.com/?utm_source=adwords&utm_medium=ppc&utm_term=visitors%20insurance&utm_campaign=VisitorsCoverage&hsa_grp=239717175&hsa_acc=3084178268&hsa_src=g&hsa_tgt=kwd-14371321&hsa_ver=3&hsa_kw=visitors%20insurance&hsa_mt=b&hsa_net=adwords&hsa_cam=7347495&hsa_ad=459453338291&gclid=Cj0KCQiA14WdBhD8ARIsANao07hHBebCjR0O6gwpOO6qQOvUtw-KiUfyxTil-ElM2I1R4odizmhh_sQaAlK3EALw_wcB"
                            [icon]="icons.faInfoCircle"
                            slot="start"
                        ></fa-icon>
                        <span>Purchase Health Insurance</span>
                    </a>
                    <span class="card-text learn-more">
                        <a class="learn-more" target="_blank" (click)="openTooltip($event, 'HealthInsurance', 'infocircle')">
                            <fa-icon [icon]="icons.faInfoCircle" slot="start"></fa-icon>
                            <span>Learn more</span>
                        </a>
                    </span>
                </div>
            </div>
        </div>
    </ion-col>
    <ion-col *ngIf="requiredDocumentList?.requireHealthInsurance" class="requirement-col" size="4" size-xs="6" size-sm="6" size-md="6" size-lg="4" size-xl="4">
        <div class="requirement-content ion-text-center">
            <ion-button
                [disabled]="checklistStatus | checklist : 'healthinsurance'"
                (click)="upload('healthinsurance', 'none')"
                fill="clear"
                color="primary"
                class="upload-btn"
            >
                <fa-icon [icon]="icons.incompleted" slot="start"></fa-icon>
                {{ userDocuments.healthinsurance ? 'Upload New Document' : 'Upload Document' }}
            </ion-button>
        </div>
    </ion-col>
    <ion-col *ngIf="requiredDocumentList?.requireHealthInsurance" class="requirement-col" size="4" size-xs="6" size-sm="6" size-md="6" size-lg="4" size-xl="4">
        <div class="requirement-content ion-text-center" *ngIf="userDocuments.healthinsurance">
            <div class="ion-padding-top">
                <ion-button
                    (click)="viewMultipleDocs(status?.applicationHealthinsuranceDocument.documents, 'healthinsurance')"
                    class="upload-btn upload-btn-color"
                    expand="block"
                    fill="clear"
                    shape="round"
                >
                    View documents
                </ion-button>
                <div class="ion-text-center chip-container">
                    <app-document-status-chip [checklist]="checklistStatus" [type]="'healthinsurance'"></app-document-status-chip>
                </div>
            </div>
        </div>
    </ion-col>
    <div class="requirement-divider"></div>
    <!-- Immunizaiton -->
    <ion-col *ngIf="requiredDocumentList?.requireImmunization" size="4" size-xs="12" size-sm="12" size-md="12" size-lg="4" size-xl="4" class="requirement-col">
        <div class="requirement-content">
            <div>
                <ion-label class="ion-text-wrap">
                    <fa-icon [icon]="icons.faFile"></fa-icon>
                    <span class="bold-text padding-left">
                        {{ (toolService.content | async)?.application?.components?.generalDocuments?.health?.immunization }}
                    </span>
                </ion-label>
                <div class="info-divs" *ngIf="status?.application?.program?.requiredpostdocumentlist?.requireImmunization && !complete?.isOnlineTelehealth">
                    <ion-text color="text">
                        <p class="card-text">
                            Download the <a href="javascript: void(0);" (click)="downloadImmuneForm()">AMO Immunization Form</a> to be filled out. Upload the
                            completed form once it is filled out, signed, and stamped by a physician. Upload the lab reports once received.
                        </p>
                    </ion-text>
                    <a href="javascript: void(0);" (click)="downloadImmuneForm()" class="anchor-btn-info">
                        <fa-icon [icon]="icons.faInfoCircle" slot="start"></fa-icon>
                        <span>AMO Immunization Form</span>
                    </a>
                    <span class="card-text learn-more">
                        <a class="learn-more" (click)="openTooltip($event, 'ImmunizationRecords', 'infocircle')">
                            <fa-icon [icon]="icons.faInfoCircle" slot="start"></fa-icon>
                            <span>Learn more</span>
                        </a>
                    </span>
                </div>
            </div>
        </div>
    </ion-col>
    <ion-col *ngIf="requiredDocumentList?.requireImmunization" size="4" size-xs="6" size-sm="6" size-md="6" size-lg="4" size-xl="4" class="requirement-col">
        <div class="requirement-content">
            <ion-button (click)="upload('immune', 'none')" fill="clear" color="primary" class="upload-btn">
                <fa-icon [icon]="icons.incompleted" slot="start"></fa-icon>
                {{ userDocuments?.immune ? 'Upload New Document' : 'Upload Document' }}
            </ion-button>
        </div>
    </ion-col>
    <ion-col *ngIf="requiredDocumentList?.requireImmunization" size="4" size-xs="6" size-sm="6" size-md="6" size-lg="4" size-xl="4" class="requirement-col">
        <div class="requirement-content">
            <div class="ion-text-center pb-3" *ngIf="status?.user?.immunizations !== 0">
                <ion-button
                    *ngIf="userDocuments.immune"
                    fill="clear"
                    class="upload-btn upload-btn-color"
                    style="text-decoration: underline"
                    (click)="viewMultipleDocs(status?.immunizations?.documents, 'immune')"
                >
                    View documents ({{ status?.immunizations?.documents.length }})
                </ion-button>
            </div>
        </div>
    </ion-col>
    <div class="requirement-divider"></div>
    <!-- VISA VISA -->
    <ion-col
        size="4"
        size-xs="12"
        size-sm="12"
        size-md="12"
        size-lg="4"
        size-xl="4"
        *ngIf="requiredDocumentList?.requireVisa && !isOnlineTelehealth && !hasUsCanPassport"
        class="requirement-col"
    >
        <div class="requirement-content">
            <div>
                <ion-label class="ion-text-wrap">
                    <fa-icon [icon]="icons.faFile"></fa-icon>
                    <span class="bold-text padding-left">
                        {{ (toolService.content | async)?.application?.components?.generalDocuments?.identity?.visaestabutton }}
                    </span>
                </ion-label>

                <ion-text
                    color="text"
                    [innerHTML]="(toolService.content | async)?.application?.components?.generalDocuments?.identity?.rightCardContentTelehealth | safe : 'html'"
                >
                </ion-text>
                <span class="card-text" *ngIf="(toolService.content | async)?.application?.components?.generalDocuments?.identity?.rightCardContentTelehealth">
                    <a class="learn-more" (click)="openTooltip($event, 'rightCardContentTelehealth', 'infocircle')">
                        <fa-icon [icon]="icons.faInfoCircle" slot="start"></fa-icon>
                        <span>Learn more</span>
                    </a>
                </span>
            </div>
        </div>
    </ion-col>
    <ion-col
        *ngIf="requiredDocumentList?.requireVisa && !isOnlineTelehealth && !hasUsCanPassport"
        class="requirement-col"
        size="4"
        size-xs="6"
        size-sm="6"
        size-md="6"
        size-lg="4"
        size-xl="4"
    >
        <div class="requirement-content ion-text-center">
            <ion-button
                [disabled]="checklistStatus | checklist : 'visaproof'"
                (click)="upload('visaproof', 'none')"
                fill="clear"
                color="primary"
                class="upload-btn"
            >
                <fa-icon [icon]="icons.incompleted" slot="start"></fa-icon>
                {{ userDocuments.visaproof ? 'Upload New Document' : 'Upload Document' }}
            </ion-button>
        </div>
    </ion-col>
    <ion-col
        *ngIf="requiredDocumentList?.requireVisa && !isOnlineTelehealth && !hasUsCanPassport"
        class="requirement-col"
        size="4"
        size-xs="6"
        size-sm="6"
        size-md="6"
        size-lg="4"
        size-xl="4"
    >
        <div class="requirement-content ion-text-center" *ngIf="userDocuments.visaproof">
            <div class="ion-padding-top">
                <ion-button (click)="viewBasicDocument('visaproof')" class="upload-btn upload-btn-color" fill="clear"> View document </ion-button>

                <div class="ion-text-center chip-container">
                    <app-document-status-chip [checklist]="checklistStatus" [type]="'visaproof'"></app-document-status-chip>
                </div>
            </div>
        </div>
    </ion-col>

    <div class="requirement-divider"></div>
    <!-- PASSPORT PASSPORT PASSPORT -->
    <ion-col class="requirement-col" size="4" size-xs="12" size-sm="12" size-md="12" size-lg="4" size-xl="4" *ngIf="requiredDocumentList?.requirePassport">
        <div class="requirement-content">
            <div>
                <ion-label class="ion-text-wrap">
                    <fa-icon [icon]="icons.faFile"></fa-icon>
                    <span class="bold-text padding-left">
                        {{ (toolService.content | async)?.application?.components?.generalDocuments?.identity?.passportbutton }}
                    </span>
                </ion-label>
                <ion-text
                    color="text"
                    [innerHTML]="(toolService.content | async)?.application?.components?.generalDocuments?.identity?.rightCardContent | safe : 'html'"
                >
                </ion-text>
            </div>
        </div>
    </ion-col>
    <ion-col class="requirement-col" size="4" size-xs="6" size-sm="6" size-md="6" size-lg="4" size-xl="4" *ngIf="requiredDocumentList?.requirePassport">
        <div class="requirement-content ion-text-center">
            <ion-button
                [disabled]="checklistStatus | checklist : 'passport'"
                (click)="upload('passport', 'none')"
                fill="clear"
                color="primary"
                class="upload-btn"
            >
                <fa-icon [icon]="icons.incompleted" slot="start"></fa-icon>
                {{ userDocuments.passport ? 'Upload New Document' : 'Upload Document' }}
            </ion-button>
        </div>
    </ion-col>
    <ion-col class="requirement-col" size="4" size-xs="6" size-sm="6" size-md="6" size-lg="4" size-xl="4" *ngIf="requiredDocumentList?.requirePassport">
        <div class="requirement-content" *ngIf="userDocuments.passport">
            <div class="ion-padding-top">
                <ion-button (click)="viewBasicDocument('passport')" class="upload-btn upload-btn-color" expand="block" fill="clear" shape="round">
                    View document
                </ion-button>

                <div class="ion-text-center chip-container">
                    <app-document-status-chip [checklist]="checklistStatus" [type]="'passport'"></app-document-status-chip>
                </div>
            </div>
        </div>
    </ion-col>
    <div class="requirement-divider"></div>
    <!-- ADDITIONAL REQUIREMENTS ADDITIONAL REQUIREMENTS ADDITIONAL REQUIREMENTS -->
    <ng-container *ngFor="let document of customDocumentList; let i = index">
        <ion-col size="4" size-xs="12" size-sm="12" size-md="12" size-lg="4" size-xl="4" class="requirement-col">
            <div class="requirement-content">
                <div>
                    <ion-label class="ion-text-wrap">
                        <fa-icon [icon]="icons.faFile"></fa-icon>
                        <span class="bold-text padding-left">
                            {{ document?.jsondata?.name }}
                        </span>
                    </ion-label>

                    <ion-text color="text" [innerHTML]="document?.jsondata?.description | safe : 'html'"> </ion-text>
                    <div class="info-divs">
                        <a
                            *ngIf="!userDocuments?.purchasedMalpractice && document?.jsondata?.type === 'malpractice'"
                            (click)="purchaseMalpractice()"
                            [disabled]="status?.application?.states !== 'Reserved' && status?.application?.states !== 'Enrolled'"
                            class="anchor-btn-info"
                        >
                            <fa-icon [icon]="icons.faInfoCircle" slot="start"></fa-icon>
                            <span>Purchase Malpractice Insurance</span>
                        </a>
                        <span *ngIf="!userDocuments?.purchasedMalpractice && document?.jsondata?.type === 'malpractice'" class="card-text learn-more">
                            <a class="learn-more" (click)="openTooltip($event, 'MalpractiseInsurance', 'infocircle')">
                                <fa-icon [icon]="icons.faInfoCircle" slot="start"></fa-icon>
                                <span>Learn more</span>
                            </a>
                        </span>
                    </div>
                </div>
            </div>
        </ion-col>
        <ion-col size="4" size-xs="6" size-sm="6" size-md="6" size-lg="4" size-xl="4" class="requirement-col">
            <div class="requirement-content">
                <div *ngIf="document?.jsondata?.type !== 'malpractice'">
                    <div *ngIf="document?.documentId && document?.jsondata?.usersubmission" class="ion-text-center">
                        <div>
                            <ion-button
                                (click)="
                                    downloadThenUploadModal(
                                        'application',
                                        document?.Document.key,
                                        document?.Document.filename,
                                        i,
                                        document?.jsondata?.name,
                                        document?.jsondata?.usersubmission,
                                        document?.applicationRequirementId,
                                        document?.level,
                                        document?.levelid
                                    )
                                "
                                class="upload-btn"
                                fill="clear"
                                color="primary"
                                [disabled]="checklistStatus | checklist : 'preapproval' : document?.applicationRequirementId"
                            >
                                <fa-icon [icon]="icons.incompleted" slot="start"></fa-icon>
                                {{ document?.submitted ? 'Download and Resubmit' : 'Download and Submit' }}
                            </ion-button>
                        </div>
                        <!-- <div>
                            <ion-text
                                class="ax_default heading_3"
                                slot="end"
                                fill="clear"
                                color="success"
                                style="text-decoration: underline; margin-left: 4px; padding-left: 0px; cursor: pointer"
                                *ngIf="userDocuments[document.jsondata.name]"
                                (click)="clearAdditionalReqDocument(document)"
                                >Clear</ion-text
                            >
                        </div> -->
                    </div>
                    <div *ngIf="!document?.Document?.key && !document?.jsondata?.usersubmission">
                        <ion-button
                            (click)="
                                downloadThenUploadModal(
                                    'application',
                                    null,
                                    null,
                                    i,
                                    document?.jsondata?.name,
                                    null,
                                    document?.applicationRequirementId,
                                    document?.level,
                                    document?.levelid
                                )
                            "
                            class="upload-btn"
                            fill="clear"
                            color="primary"
                            [disabled]="checklistStatus | checklist : 'preapproval' : document?.applicationRequirementId"
                        >
                            <fa-icon [icon]="icons.acknowledged" slot="start"></fa-icon>
                            Acknowledge
                        </ion-button>
                    </div>
                    <div *ngIf="document?.Document?.key && !document?.jsondata?.usersubmission">
                        <ion-button
                            (click)="
                                downloadThenUploadModal(
                                    'application',
                                    document?.Document.key,
                                    document?.Document.filename,
                                    i,
                                    document?.jsondata?.name,
                                    document?.jsondata?.usersubmission,
                                    document?.applicationRequirementId,
                                    document?.level,
                                    document?.levelid
                                )
                            "
                            class="upload-btn"
                            fill="clear"
                            color="primary"
                            [disabled]="checklistStatus | checklist : 'preapproval' : document?.applicationRequirementId"
                        >
                            <fa-icon [icon]="icons.download" slot="start"></fa-icon>
                            {{ document?.submitted ? 'Download Again' : 'Download' }}
                        </ion-button>
                    </div>
                    <div *ngIf="!document?.documentId && document?.jsondata?.usersubmission" class="ion-text-center">
                        <div>
                            <ion-button
                                (click)="
                                    downloadThenUploadModal(
                                        'application',
                                        null,
                                        null,
                                        i,
                                        document?.jsondata?.name,
                                        document?.jsondata?.usersubmission,
                                        document?.applicationRequirementId,
                                        document?.level,
                                        document?.levelid
                                    )
                                "
                                class="upload-btn"
                                fill="clear"
                                color="primary"
                                [disabled]="checklistStatus | checklist : 'preapproval' : document?.applicationRequirementId"
                            >
                                <fa-icon [icon]="icons.incompleted" slot="start"></fa-icon>
                                {{ document?.submitted ? 'Upload New Document' : 'Upload Document' }}
                            </ion-button>
                        </div>
                        <!-- <div>
                            <ion-text
                                class="ax_default heading_3"
                                slot="end"
                                fill="clear"
                                color="success"
                                style="text-decoration: underline; margin-left: 4px; padding-left: 0px; cursor: pointer"
                                *ngIf="userDocuments[document.jsondata.name]"
                                (click)="clearAdditionalReqDocument(document)"
                                >Clear</ion-text
                            >
                        </div> -->
                    </div>
                </div>
                <div *ngIf="document?.jsondata?.type === 'malpractice'">
                    <div class="ion-text-center" *ngIf="!userDocuments?.purchasedMalpractice">
                        <ion-button
                            [disabled]="checklistStatus | checklist : 'preapproval' : document?.applicationRequirementId"
                            (click)="upload('malpractice', 'none')"
                            class="upload-btn"
                            fill="clear"
                            color="primary"
                        >
                            <fa-icon [icon]="icons.incompleted" slot="start"></fa-icon>
                            {{ userDocuments?.purchasedMalpractice ? 'Upload New Document' : 'Upload Document' }}
                        </ion-button>
                        <ion-text
                            class="ax_default heading_3"
                            slot="end"
                            fill="clear"
                            color="success"
                            style="text-decoration: underline; margin-left: 4px; padding-left: 0px; cursor: pointer"
                            *ngIf="userDocuments[document.jsondata.name]"
                            (click)="clearAdditionalReqDocument(document)"
                            >Clear</ion-text
                        >
                    </div>
                </div>
            </div>
        </ion-col>
        <ion-col size="4" size-xs="6" size-sm="6" size-md="6" size-lg="4" size-xl="4" class="requirement-col">
            <div class="requirement-content">
                <div class="ion-text-center" *ngIf="userDocuments?.purchasedMalpractice && document?.jsondata?.type === 'malpractice'">
                    <ion-button (click)="viewMalpracticeDocument()" class="custom-document-button-complete">
                        <!-- <fa-icon [icon]="icons.file" slot="start"></fa-icon> -->
                        <ng-container [ngTemplateOutlet]="selectIconOnCondition"></ng-container>
                        <ion-text class="ion-text-wrap">
                            {{ (toolService.content | async)?.application?.components?.generalDocuments?.health?.viewmalpractice }}
                        </ion-text>
                    </ion-button>

                    <div class="ion-text-center chip-container">
                        <app-document-status-chip [checklist]="checklistStatus" [requirementId]="document?.applicationRequirementId"></app-document-status-chip>
                    </div>
                    <!-- <ion-icon class="doc-comp" size="medium" color="success" name="checkmark-circle-outline"></ion-icon> -->
                    <!-- <ion-icon class="doc-comp" size="medium" color="danger" name="alert"></ion-icon> -->
                </div>
                <div *ngIf="document?.jsondata?.type !== 'malpractice' && userDocuments[document.jsondata.name]">
                    <div class="ion-padding-top">
                        <ion-button
                            *ngIf="document?.urlSubmitted"
                            (click)="viewAdditionalDocument(document, document?.urlSubmitted)"
                            class="upload-btn upload-btn-color"
                            expand="block"
                            fill="clear"
                            shape="round"
                        >
                            View document
                        </ion-button>

                        <div class="ion-text-center chip-container">
                            <app-document-status-chip
                                [checklist]="checklistStatus"
                                [requirementId]="document?.applicationRequirementId"
                            ></app-document-status-chip>
                        </div>
                    </div>
                </div>
            </div>
        </ion-col>
        <div class="requirement-divider"></div>
    </ng-container>
</ion-row>
<a class="download-zip-link" #downloadZipLink></a>

<ng-template #selectIconOnCondition>
    <fa-icon [icon]="icons.rejectedOrAccepted" slot="start" class="rejectedOrAccepted icons"></fa-icon>
    <!-- <fa-icon  [icon]="icons.rejectedOrAccepted" slot="start"></fa-icon> -->
    <fa-icon [icon]="icons.incompleted" slot="start" class="incompleted icons"></fa-icon>
    <fa-icon [icon]="icons.completed" slot="start" class="completed icons"></fa-icon>
    <fa-icon [icon]="icons.blocked" slot="start" class="blocked icons"></fa-icon>
    <!-- <fa-icon  [icon]="icons.incompleted" slot="start" class="noclass"></fa-icon> -->
</ng-template>
